const items = [
  "AUDI", "MERCEDES-BENZ", "BMW", "FIAT", "VOLKSWAGEN", "ALFA ROMEO",
  "PEUGEOT", "CITROEN", "OPEL", "FORD", "NISSAN", "TOYOTA", "JEEP",
  "LANCIA", "DACIA", "SEAT", "MOTORI TESTATI E VERIFICATI", "PREZZI SCONTATI",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      data-testid="brand-marquee"
      className="relative overflow-hidden border-b border-[#272A38] bg-[#12141C] py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        {row.map((item, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display px-6 text-2xl font-black uppercase italic tracking-wide ${
                item.length > 20 ? "text-[#F59E0B]" : "text-stroke-faint"
              }`}
            >
              {item}
            </span>
            <span className="h-2 w-2 rotate-45 bg-[#F59E0B]/60" />
          </span>
        ))}
      </div>
    </div>
  );
}
